import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import {
	buildInitialTrafficRow,
	updateTrafficRows,
	validateTrafficRows,
	loadingStatus,
	getPayload
} from "../../actions"
import settings from "settings"
import axios from "axios"
import { compose } from "redux"
import Title from "../general/title"
import transformOptions from "../../helpers/transformOptions"
import * as Yup from "yup"
import { Formik, Field, Form } from "formik"
import Select from '../../components/Select'
import submitData from '../../helpers/submitData'

class EditTraffic extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading:true,
			redirect:false,
			redirectPath: '',
			fields: {
				builder_id: "",
				neighborhood: "",
				trafficSources: "",
				name: "",
				zip: "",
				email: ""
			}
		}
	}

	componentDidMount() {
		this.props.loadingStatus(true)
		// get the sale data
		this.props.match.params
		var userToken = localStorage.getItem("user")

		axios
			.post(settings.ep + "/getTrafficRow", data, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then(response => {
				//console.log(response.data)
				this.setState({fields:response.data, loading:false}, () => {
					console.log(this.state)
				})
				this.props.loadingStatus(false)
			})
			.catch(error => {
				// need error handling
				this.props.loadingStatus(false)
			})
	}

	test = () => {
		console.log(this.state)
		//console.log(this.state)
	}

	validation = () => {
		return Yup.object().shape({
			email: Yup.string().email("Invalid email address").required("Required"),
			name: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			zip: Yup.string().min(5, "Must be 5 characters").max(5, "Must be 5 characters").required("Required"),
			source: Yup.string().required('Required'),
			builder_id: Yup.string().required('Required'),
			neighborhood: Yup.string().required('Required'),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f
		})

		return submitClasses
	}

	fieldStatus = (id, f) => {
		var classNames = require("classnames")
		return classNames("form__listItem", {
			'form__fieldGroup--active': f.touched[id],
            'form__fieldGroup--error': f.errors[id] && f.touched[id],
            'form__fieldGroup--success': !f.errors[id] && f.values[id]
		})
	}

	render() {
		if(this.state.loading) {
			return ''
		}
		else if(this.state.redirect) {
			return(<Redirect to={this.state.redirectPath} />)
		}
		return (
			<div>
				<Formik
					initialValues={this.state.fields}
					validationSchema={this.validation}
					isInitialValid={true}
					validateOnMount={true}
					onSubmit={(values) => {
						this.props.loadingStatus(true)
						submitData('editTraffic', values).then((data) => {
							this.props.loadingStatus(false)
							this.setState({
								redirect:true,
								redirectPath:data.redirect
							}, () => {
								this.props.getPayload()
							})
						})
					}}
					render={ f => (
						<div className="traffic">
							<Title title="Traffic" />
							<div className="fullCol">
								<h3>Edit Traffic</h3>
								<Form>
									<ul className="form__list">
										<li className={this.fieldStatus('builder_id', f)}>
											<label htmlFor="builder_id">
												Builder <sup>*</sup>
											</label>
											{f.errors.builder_id && f.touched.builder_id && (
												<div className="form__message">
													{f.errors.builder_id}
												</div>
											)}
											<Select
												name="builder_id"
												options={transformOptions(this.props.payload.builders)}
												className="form__input"
												value={f.values.builder_id}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.builder_id}
												error={f.errors.builder_id}
											/>
										</li>
										<li className={this.fieldStatus('neighborhood', f)}>
											<label htmlFor="neighborhood">
												Neighborhood <sup>*</sup>
											</label>
											{f.errors.neighborhood && f.touched.neighborhood && (
												<div className="form__message">
													{f.errors.neighborhood}
												</div>
											)}
											<Select
												name="neighborhood"
												options={transformOptions(this.props.payload.neighborhoods)}
												className="form__input"
												value={f.values.neighborhood}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.neighborhood}
												error={f.errors.neighborhood}
											/>
										</li>
										<li className={this.fieldStatus('source', f)}>
											<label htmlFor="source">
												Traffic Source <sup>*</sup>
											</label>
											{f.errors.source && f.touched.source && (
												<div className="form__message">
													{f.errors.source}
												</div>
											)}
											<Select
												name="source"
												options={transformOptions(this.props.payload.trafficSources)}
												className="form__input"
												value={f.values.source}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.source}
												error={f.errors.source}
											/>
										</li>
										<li className={this.fieldStatus('name', f)}>
											<label htmlFor="firstName">
												Name <sup>*</sup>
											</label>
											{f.errors.name && f.touched.name && (
												<div className="form__message">
													{f.errors.name}
												</div>
											)}
											<Field
												name="name"
												type="text"
												className="form__input"
											/>
										</li>
										<li className={this.fieldStatus('zip', f)}>
											<label htmlFor="zip">
												Zip <sup>*</sup>
											</label>
											{f.errors.zip && f.touched.zip && (
												<div className="form__message">
													{f.errors.zip}
												</div>
											)}
											<Field
												name="zip"
												type="text"
												className="form__input"
											/>
										</li>
										<li className={this.fieldStatus('email', f)}>
											<label htmlFor="email">
												Email <sup>*</sup>
											</label>
											{f.errors.email && f.touched.email && (
												<div className="form__message">
													{f.errors.email}
												</div>
											)}
											<Field
												name="email"
												type="email"
												className="form__input"
											/>
										</li>
									</ul>
									<input
										type="submit"
										value="Submit"
										className={this.submitClasses(f.isValid)}
									/>
								</Form>
							</div>
						</div>
					)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficRows: state.trafficRows,
		trafficSources: state.trafficSources,
		payload: state.payload
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			buildInitialTrafficRow,
			updateTrafficRows,
			validateTrafficRows,
			loadingStatus,
			getPayload
		},
		dispatch
	)
}

export default compose(
	connect(mapStateToProps, matchDispatchToProps)
)(EditTraffic)
